"use strict";
exports.__esModule = true;
exports.toIcon = void 0;
var PRISMIC_ICON = {
    Rechercher: 'search',
    Télécharger: 'download',
    'Espace presse': 'newsroom',
    'Informations financières': 'financial'
};
var toIcon = function (value) {
    return value ? PRISMIC_ICON[value] : undefined;
};
exports.toIcon = toIcon;
//# sourceMappingURL=icon.js.map